import React from 'react';
import { useTranslation } from 'react-i18next';

import { CircularLoader } from '../loader/CircularLoader';

export const DataTableDataLoader = () => {
  const { t } = useTranslation();
  return <CircularLoader backdrop fullPage content={t('common.placeholders.loadingData')} />;
};
